/*
 * @Description: 密码修改
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-22 20:00:45
 * @LastEditTime: 2019-07-24 14:42:13
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

// 查询用户个人信息(只用到手机号)
export const getInformation = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/user`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getSysUser'
      }, params))
    }
  })
}
// 修改密码
export const changePassword = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/user`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'editPwd'
      }, params))
    }
  })
}
// 解绑手机号
export const untyingPhone = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/user`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'unbindPhone'
      }, params))
    }
  })
}
// 获取验证码
// export const getCode = (params) => {
//   return logistice({
//     url: `${LOGISTICE_GATEWAY}/website/index/user`,
//     method: 'post',
//     params: {
//       params: JSON.stringify(Object.assign({
//         methodName: 'getCodeForInputPhone'
//       }, params))
//     }
//   })
// }
export const getCode = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/systemUser`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'createSmsCode'
      }, params))
    }
  })
}
